import type { LanguageCode } from "config/languages";

export const getLocaleFromUrl = (url: string) =>
  url?.startsWith("/") ? (url?.split("/")[1] as LanguageCode) : (url?.split("/")[0] as LanguageCode);
